import { theme } from '@prophecy/theme';
import { Input, LabelWithHint, Switch } from '@prophecy/ui-v3';
import React from 'react';
import { Controller } from 'react-hook-form';

import { getClientIdLabel, getCrendetialsLabel } from '../../utils';
import { SCIMField } from './ProphecyManaged';
import { ScrollableStack } from './styled';
import { ComponentProps } from './types';

export default function AzureAuth(props: ComponentProps & { isAzureSCIMEnabled?: boolean }) {
  const { control, errors, IsUsingManagedIdentity, isAzureSCIMEnabled } = props;
  return (
    <ScrollableStack gap={theme.spaces.x24}>
      {/*<Controller
        render={({ field }) => (
          <UserPrompt
            hasPrompt={!props.isSCIMEnabled || props.isSCIMV1}
            errorMsg={errors?.azuread?.usernamePrompt?.message}
            value={field.value}
            onChange={field.onChange}
          />
        )}
        control={control}
        name='azuread.usernamePrompt'
      />*/}
      {isAzureSCIMEnabled && <SCIMField {...props} isAzure />}
      <Controller
        render={({ field }) => (
          <Input
            label={<LabelWithHint hint={getClientIdLabel('azure')}>* Client ID</LabelWithHint>}
            {...field}
            variant={errors?.azuread?.clientID ? 'error' : 'primary'}
            helpText={errors?.azuread?.clientID?.message}
            data-test-id='azure-auth-client-id-input'
          />
        )}
        control={control}
        name='azuread.clientID'
        rules={{
          required: 'Client is required'
        }}
      />
      <Controller
        render={({ field }) => (
          <Switch checked={field.value} onChange={field.onChange} data-test-id='azure-auth-managed-identity-switch'>
            UseManagedIdentity
          </Switch>
        )}
        control={control}
        name='azuread.IsUsingManagedIdentity'
      />
      <Controller
        render={({ field }) => (
          <Input
            label={<LabelWithHint hint={getCrendetialsLabel('azure')}>Client Secret</LabelWithHint>}
            {...field}
            required={!IsUsingManagedIdentity}
            disabled={!!IsUsingManagedIdentity}
            value={IsUsingManagedIdentity ? '' : field.value}
            variant={errors?.azuread?.clientSecret ? 'error' : 'primary'}
            helpText={errors?.azuread?.clientSecret?.message}
            data-test-id='azure-auth-client-secret-input'
          />
        )}
        control={control}
        name='azuread.clientSecret'
        rules={
          IsUsingManagedIdentity
            ? {
                required: 'Client secret is required'
              }
            : {}
        }
      />
      <Controller
        render={({ field }) => (
          <Input
            label={<LabelWithHint hint='Your Azure Active Directory Tenant Name'>Tenant Name</LabelWithHint>}
            {...field}
            data-test-id='azure-auth-tenant-name-input'
          />
        )}
        control={control}
        name='azuread.tenant'
      />
    </ScrollableStack>
  );
}
